import { render, staticRenderFns } from "./RoleListPage.vue?vue&type=template&id=42199493&"
import script from "./RoleListPage.vue?vue&type=script&lang=js&"
export * from "./RoleListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports